export enum NodeType {
  Sender = 'Sender',
  Coin = 'Coin',
  Receiver = 'Receiver',
}
